import React from 'react';

function CartSummary(props) {
/* 
  function convert(num) {
    //console.log(num);
    return num.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    //return num;
  }

       <div className="riga_riepilogo_ordine">
          <p className="sx_riepilogo_ordine">Totale prodotti:</p>
          <p className="dx_riepilogo_ordine">
            &euro; {props.convert(props.order.totale_prodotti)}
          </p>
        </div>

*/
  //console.log(props);
  return (
    <div className="riepilogo_ordine">
      <div className="titolo_riepilogo_ordine">
        <h2>Riepilogo</h2>
      </div>

      <div className="elenco_riepilogo_ordine">
        <div className="riga_riepilogo_ordine">
          <p className="sx_riepilogo_ordine">Spese di spedizione:</p>
          {props.order.costo_spedizione > 0 ? (
            <p className="dx_riepilogo_ordine">
              &euro; {props.convert(props.order.costo_spedizione)}
            </p>
          ) : (
            <p className="dx_riepilogo_ordine">gratuite</p>
          )}
        </div>        
        {props.order.costo_pagamento > 0 ? (
          <div className="riga_riepilogo_ordine">
            <p className="sx_riepilogo_ordine">Costo pagamento:</p>
            <p className="dx_riepilogo_ordine">
              &euro; {props.convert(props.order.costo_pagamento)}
            </p>
          </div>
        ) : null}
        {props.order.valore_sconto > 0 ? (
          <div className="riga_riepilogo_ordine">
            <p className="sx_riepilogo_ordine">Totale sconto:</p>
            <p className="dx_riepilogo_ordine">
              &euro; {props.convert(-props.order.valore_sconto)}
            </p>
          </div>
        ) : null}
        {props.order.credito_utilizzabile > 0 &&
        props.order.usa_credito === "1" ? (
          <div className="riga_riepilogo_ordine">
            <p className="sx_riepilogo_ordine">Credito:</p>
            <p className="dx_riepilogo_ordine">
              &euro; {props.convert(-props.order.credito_utilizzabile)}
            </p>
          </div>
        ) : null}
        <div className="riga_riepilogo_ordine">
          <p className="sx_riepilogo_ordine">Totale:</p>
          <p className="dx_riepilogo_ordine">
            &euro; {props.convert(props.order.totale)}
          </p>
        </div>
        <div className="clear"></div>
      </div>
    </div>
  );
}

export default CartSummary;